import { createSelector } from '@ngrx/store';

import { IHeaderAlert } from '../../services/header-service/header-alerts.service';
import { selectCoreState } from '../core-feature-selector';
import IHeaderAlertsState from './header-alerts.state';

const selectHeaderAlertManagement = createSelector(
  selectCoreState,
  (state) => state.headerAlerts,
);

export const selectAllHeaderAlerts = createSelector(
  selectHeaderAlertManagement,
  (headerAlertsState: IHeaderAlertsState) =>
    Object.values(headerAlertsState || {}) as IHeaderAlert[],
);

export const selectNumberOfHeaderAlerts = createSelector(
  selectHeaderAlertManagement,
  (headerAlertsState: IHeaderAlertsState) =>
    Object.values(headerAlertsState || {}).length,
);

export const selectAlertBannerPresent = createSelector(
  selectNumberOfHeaderAlerts,
  (numAlerts) => numAlerts > 0,
);

export const selectBeforeUnloadHeaderAlerts = createSelector(
  selectHeaderAlertManagement,
  (headerAlertsState: IHeaderAlertsState) =>
    (Object.values(headerAlertsState || {}) as IHeaderAlert[]).filter(
      (alert) => !!alert.beforeUnload,
    ),
);
